import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/memberships/attrition_and_cancel_reasons"
});

export const api = {
  getFilters(params) {
    return instance.get("/get_filters", params);
  },
  getData(params) {
    return instance.post("/get_table", params);
  },
  getIlearn(params) {
    return instance.get("/ilearn", params);
  }
};
